import { Inbox } from 'lucide-react';

const EmptyState = ({ title = 'No data found', description = 'There are no items to display.', icon: Icon = Inbox }) => {
    return (
        <div className="empty-state text-center py-5">
            <Icon size={48} className="text-muted mb-3" strokeWidth={1.5} />
            <h5 className="text-muted">{title}</h5>
            <p className="text-muted small">{description}</p>
        </div>
    );
};

export default EmptyState;
